export default function accordionWidget(editor) {
  editor.DomComponents.addType('eb-accordion', {
    isComponent(el) {
      return el.getAttribute && el.getAttribute('data-gjs-type') === 'eb-accordion'
    },
    model: {
      defaults: {
        name: 'Accordion',
        tagName: 'div',
        droppable: false,
        attributes: { 'data-gjs-type': 'eb-accordion' },
        style: { 'padding': '10px' },
        components: `
          <style>
            .eb-accordion-wrap details { border: 1px solid #e0e0e0; border-radius: 6px; margin-bottom: 8px; overflow: hidden; }
            .eb-accordion-wrap details summary { padding: 14px 20px; font-size: 15px; font-weight: 600; color: #333; cursor: pointer; background: #f9f9f9; list-style: none; display: flex; justify-content: space-between; align-items: center; transition: background 0.2s; }
            .eb-accordion-wrap details summary:hover { background: #f0f0f0; }
            .eb-accordion-wrap details summary::-webkit-details-marker { display: none; }
            .eb-accordion-wrap details summary::after { content: '+'; font-size: 20px; font-weight: 300; color: #667eea; transition: transform 0.2s; }
            .eb-accordion-wrap details[open] summary::after { content: '−'; }
            .eb-accordion-wrap details .eb-acc-content { padding: 16px 20px; font-size: 14px; color: #555; line-height: 1.7; border-top: 1px solid #e0e0e0; }
          </style>
          <div class="eb-accordion-wrap">
            <details open>
              <summary>Accordion Item 1</summary>
              <div class="eb-acc-content">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.</div>
            </details>
            <details>
              <summary>Accordion Item 2</summary>
              <div class="eb-acc-content">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.</div>
            </details>
            <details>
              <summary>Accordion Item 3</summary>
              <div class="eb-acc-content">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.</div>
            </details>
          </div>
        `,
        traits: [],
      },
    },
  })

  editor.BlockManager.add('eb-accordion', {
    label: 'Accordion',
    category: 'General',
    media: '<svg viewBox="0 0 24 24"><path fill="currentColor" d="M3,3H21V5H3V3M3,7H21V9H3V7M3,11H21V13H3V11M3,15H21V17H3V15M3,19H21V21H3V19Z"/></svg>',
    content: { type: 'eb-accordion' },
  })
}
